import { getRouteApi } from '@tanstack/react-router'
import { HistoryTable } from 'bank-entity-history/src/components/HistoryTable/HistoryTable'
import { TableDataQa } from 'commons/types/enums'
import { Layer, PageSection } from 'ui/components'

export const HistorySection = () => {
  const routeApi = getRouteApi('/_app/documents/$documentId/periods/$periodId')
  const navigate = routeApi.useNavigate()
  const search = routeApi.useSearch()
  const data = routeApi.useLoaderData()

  const onHistoryPagination = (historyPage: number, historySize: number) => {
    navigate({
      to: '/documents/$documentId/periods/$periodId',
      resetScroll: false,
      replace: true,
      search: { historyPage, historySize }
    })
  }

  return (
    <PageSection title="Document Period History">
      <Layer rounded shadowed>
        <HistoryTable
          dataQa={TableDataQa.BP_DOCUMENTS_PERIOD_HISTORY}
          items={data.history}
          loading={false}
          pagination={{
            page: search.historyPage || 1,
            size: search.historySize || 10,
            onChange: onHistoryPagination,
            // @ts-ignore can't find historyTotal in the search scheme
            total: search.historyTotal || 0
          }}
        />
      </Layer>
    </PageSection>
  )
}
